import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=282cc6c6&scoped=true&"
import script from "./SystemMessage.vue?vue&type=script&lang=js&"
export * from "./SystemMessage.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&id=282cc6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cc6c6",
  null
  
)

export default component.exports